<template>
  <CommonDrop
    v-model="currentValue"
    url="/trade/storages/list"
    :autoDefault="autoDefault"
    :disabled="disabled"
    :defaultItem="defaultItem"
    :filterable="true"
    :remote="true"
    :size="size"
    ref="drop"
    :params="{ids:ids.join(',')}"
    :clearable="clearable"
  ></CommonDrop>
</template>
<script>
import CommonDrop from "@/components/CommonDrop";
export default {
  components: { CommonDrop },
  name: "storages",
  props: {
    ids:{
      type:Array,
      default:()=>{
        return []
      }
    },
    value: {
      type: String | Number,
      default: null,
    },
    autoDefault: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    defaultItem: {
      type: Object,
      default: () => {
        return {
          id: "",
          label: "请选择",
        };
      },
    },
    size:{
      type:String,
      default:'mini'
    },
    clearable:{
      type:Boolean,
      default:false
    }
  },

  computed: {
    currentValue: {
      get() {
        if (this.value === null || this.value === undefined) {
          return "";
        }
        return String(this.value);
      },
      set(newVal) {
        this.$emit("input", newVal);
        this.$emit("change", newVal);
      },
    },
  },
  methods: {
    getDataList(){
      this.$refs.drop.getDataList()
    }
  },
};
</script>
